<div class="bp-asset-list">
  <div class="bp-asset-list-search-bar">
    <bp-search-bar
      (searchValueChange)="onSearchValueChange($event)"
    [placeholder]="'search_bar_placeholder_buy' | translate"></bp-search-bar>
  </div>

  <div class="bp-asset-list-filter">
    <bp-toggle-group
      [options]="filterListFF$ | async"
      [selected]="filters[0]"
      (onValueChange)="onFilterChange($event)">
    </bp-toggle-group>
  </div>

  @if (pillsThatNeedRealSecuritiesBanner | include_pipe: (filterValue | lowercase)) {
    @if (ownedLegacyAssets > 0) {
      <div class="digi-sunset-banner">
        <sunset-digi-banner [isPortfolioBanner]="true" [ownedAssets]="ownedLegacyAssets"></sunset-digi-banner>
      </div>
    }
    <div class="margin_security_banner">
      @if (isLimitOrder) {
        <real-securities-banner
          [title]="'inline_banner_real_securities_limit_orders_title' | translate"
          [subtitle]="'go_to_mobile_app_cta' | translate" />
      } @else {
        @let realSecuritiesRedirectionType = (realSecuritiesRedirectionType$ | async).value;
        @if(realSecuritiesRedirectionType === REDIRECTION_TYPE.PLAN_A) {
          <real-securities-banner
            [title]="'inline_banner_real_securities_trade_title' | translate: [getRSFeeText()]"
            [subtitle]="'inline_banner_real_securities_trade_subtitle' | translate"
            [linkTitle]="'discover_stocks_cta' | translate"
            [linkURL]="getV4RedirectURL()" />
        } @else if (realSecuritiesRedirectionType === REDIRECTION_TYPE.PLAN_B) {
          <real-securities-banner
            [title]="'inline_banner_real_securities_plan_b_title' | translate: [getRSFeeText()]"
            [subtitle]="'inline_banner_real_securities_coming_soon_web' | translate" />
        }
      }
    </div>
  }

  @if (tradables$ | async; as tradables) {
    <div class="bp-asset-list-table">
      <bp-table [items]="tradables" [(scrollToTop)]="scrollToTop" (itemClicked)="onClick($event)">
        <ng-template [bpTableHeader]="tradables">
          <div bpTableHeaderCell>
            {{ "all_charts_price_column_label_name" | translate }}
          </div>
          <div bpTableHeaderCell>
            {{ "tradable_list_selection_legend_own" | translate }}
          </div>
          <div bpTableHeaderCell>
            {{ "tradable_list_selection_legend_value" | translate }}
          </div>
        </ng-template>
        <ng-template [bpTableRow]="tradables" let-tradable>
          <div bpTableCell>
            <img
              bpTableCellLogo
              [src]="tradable.getLogo()"
              (error)="img.src = tradable.getDefaultLogo()"
              alt="{{ 'logo_alt_text' | translate }}"
              #img />
            <div class="flex flex-col text-color">
              <div bpTableCellLine bpTableOverflowEllipsis>
                {{ tradable.getName() }}
              </div>
              <div bpTableCellLine>
                {{ tradable.getSymbol(false, true) }}
              </div>
            </div>
            @if (tradableIsLegacy(tradable)) {
              <legacy-label />
            }
          </div>
          <div bpTableCell class="bp-asset-list-own">
            @if (tradable.getCurrencyType() === INDEX_TYPE) {
              {{
              getWalletSum(tradable)
              | fiat_precision_symbol
              : {
              id: defaultFiat.getId(),
              currencies: [defaultFiat, tradable],
              customPrecision: 2,
              noTrailingZeros: true,
              symbol: true
            }
            }}
          } @else {
            {{ getWalletSum(tradable) | tradable_precision_symbol: { id: tradable?.getId() } }}
          }
        </div>
        <div bpTableCell class="bp-asset-list-own-fiat text-color">
          {{
          getWalletSumFiat(tradable)
          | fiat_precision_symbol
          : { id: defaultFiat?.getId(), symbol: true, currencies: [defaultFiat] }
          }}
        </div>
      </ng-template>
    </bp-table>
  </div>
}
</div>
